var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.kpi)?_c('span',[_vm._v(_vm._s(_vm.formattedValue))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }